// @ngInject
function RolesApiService(ResourcesService) {

    var endpoint = 'roles';

    return {
        getAllClaims: ResourcesService.apiFactory.get(endpoint + '/claims'),
        getAllRoles: ResourcesService.apiFactory.get(endpoint),
        getAllWidgets: ResourcesService.apiFactory.get(endpoint + '/widgets'),
        getAllDataSources: ResourcesService.apiFactory.get(endpoint + '/datasources'),
        getRole: ResourcesService.apiFactory.get(endpoint),
        updateRole: ResourcesService.apiFactory.update(endpoint)
    };

}

angular.module('roles.api', [])
  .factory('RolesApiService', RolesApiService);
